import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { FilterButton } from 'src/components/FilterButton/FilterButton';
import { getIsMobileWithTouchscreen } from 'src/store/agent/selectors';
import { getSearchFiltersCount } from 'src/store/search/selectors';
import { searchActions } from 'src/store/search/slice';
import { sidesheetActions } from 'src/store/sidesheet/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';

export const SearchFilterButton: FC = () => {
  const isMobile = useSelector(getIsMobileWithTouchscreen);

  const dispatch = useAppDispatch();
  const filtersCount = useSelector(getSearchFiltersCount);

  const open = useCallback(() => {
    if (isMobile) {
      dispatch(searchActions.openFilters());
    } else {
      dispatch(sidesheetActions.open('searchFilters'));
    }
  }, [dispatch, isMobile]);

  return (
    <FilterButton
      onClick={open}
      filtersCount={filtersCount}
      testId='searchFilterButton'
    />
  );
};
